<a class="cross-selling-banner" [ngClass]="{ isSidebar: inSidebar }"
   [ngStyle]="{ 'background-image': 'url(' + image + ')' }"
   [href]="link" target="_blank">
    <div class="container">
        <div class="cross-selling-banner-title">
            {{ title | translate }}
        </div>
        <span class="btn btn-success cross-selling-banner-btn">
            <span>{{ 'CROSS_SELLING_VISIT_WEBSITE' | translate }}</span>
            <fa-icon class="ms-2" size="lg" [icon]="['fal', 'arrow-up-right-from-square']"></fa-icon>
        </span>
    </div>
</a>
